const features = [
  {
    title: '庆余年3 · 权谋终章',
    desc: '范闲归来，京都风云变幻，第三季高潮迭起，每周持续更新中。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20scene%20with%20golden%20palace%20interior%2C%20warm%20amber%20lighting%2C%20dramatic%20composition%2C%20cinematic%20wide%20shot%2C%20ancient%20costume%20aesthetic%2C%20soft%20atmospheric%20glow&width=600&height=360&seq=carousel-feature-01&orientation=landscape',
  },
  {
    title: '背着善宰跑 · 穿越时空的爱',
    desc: '年度韩剧黑马，金惠允与边佑锡的奇幻浪漫之旅。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20scene%20with%20cherry%20blossoms%20and%20soft%20sunlight%2C%20warm%20golden%20hour%20glow%2C%20dreamy%20atmosphere%2C%20young%20couple%20walking%20together%2C%20cinematic%20composition&width=600&height=360&seq=carousel-feature-02&orientation=landscape',
  },
  {
    title: '繁花 · 岁月流金',
    desc: '王家卫镜头下的上海滩，胡歌演绎商海传奇。',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20Shanghai%20street%20at%20night%20with%20warm%20neon%20signs%2C%20vintage%201990s%20atmosphere%2C%20golden%20and%20amber%20tones%2C%20cinematic%20noir%20aesthetic%2C%20rain-slicked%20streets%2C%20elegant%20mood&width=600&height=360&seq=carousel-feature-03&orientation=landscape',
  },
  {
    title: '墨雨云间 · 古装悬疑',
    desc: '复仇与救赎交织，精致服化道引爆国产古装剧新热潮。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20courtyard%20in%20misty%20rain%2C%20dramatic%20lighting%2C%20historical%20drama%20aesthetic%2C%20warm%20amber%20and%20dark%20tones%2C%20atmospheric%20and%20suspenseful%20mood%2C%20cinematic%20composition&width=600&height=360&seq=carousel-feature-04&orientation=landscape',
  },
  {
    title: '泪之女王 · 豪门风云',
    desc: '金秀贤金智媛夫妇演绎豪门悲欢，收视率屡创新高。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20interior%20with%20warm%20chandelier%20lighting%2C%20romantic%20Korean%20drama%20scene%2C%20golden%20and%20cream%20tones%2C%20sophisticated%20atmosphere%2C%20emotional%20and%20tender%20mood%2C%20cinematic%20wide%20shot&width=600&height=360&seq=carousel-feature-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full mb-3">
              重磅推荐
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">本周不容错过的五部热播大剧</p>
          </div>

          <div className="flex flex-wrap justify-center gap-5 md:gap-6">
            {features.map((item, i) => (
              <article
                key={i}
                className="group w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] xl:w-[calc(20%-20px)] bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer flex flex-col"
              >
                <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                  <span className="absolute top-3 left-3 w-7 h-7 rounded-full bg-background-50/90 backdrop-blur-sm flex items-center justify-center text-xs font-bold text-foreground-900">
                    {i + 1}
                  </span>
                </div>
                <div className="p-4 flex-1 flex flex-col">
                  <h3 className="text-sm font-bold text-foreground-900 mb-1.5 font-heading group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}